<template>
    <div class="wrapper">
        <h2 class="page_title">{{ $t("page.kommo-crm.mainheader") }}</h2>
        <div class="container_block">
            <OrderedListRecurring :list="instruction" />
            <img src="@/assets/amo-crm/screen.png" class="image" />
        </div>
        <div class="card_flex d-flex justify-content-between gap-3">
            <BaseCardInstruction
                :text="$t('page.kommo-crm.text4')"
                :buttonText="$t('common.instruction')"
                @clickButton="onClickInstructions"
            />
            <BaseCardInstruction
                :text="$t('page.kommo-crm.text5')"
                :buttonText="$t('page.kommo-crm.button1')"
                :bIcon="'question-circle-fill'"
                @clickButton="onClickQuestions"
            />
        </div>
        <BaseCardInstruction>
            <div class="listText">
                <p v-for="text in afterActivation" :key="text" class="my-3">
                    {{ $t(text) }}
                </p>
            </div>
        </BaseCardInstruction>
    </div>
</template>
<script>
import OrderedListRecurring from "@/components/Recurring/OrderedListRecurring.vue";
import BaseCardInstruction from "@/components/Instruction/BaseCardInstruction.vue";

export default {
    components: {
        OrderedListRecurring,
        BaseCardInstruction,
    },
    data() {
        return {
            instruction: [
                "page.kommo-crm.text1",
                "page.kommo-crm.text2",
                "page.kommo-crm.text3",
            ],
            afterActivation: [
                "page.kommo-crm.text6",
                "page.kommo-crm.text7",
                "page.kommo-crm.text8",
            ],
        };
    },
    methods: {
        onClickInstructions() {
            window.open("https://e-chat.tech/guides/first_tutorial.php");
        },
        onClickQuestions() {
            window.open(
                "https://sites.google.com/view/e-chat-amocrm/?pli=1#h.fh9hhxtaes6j"
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.listText {
    margin-top: -16px;
    margin-bottom: -16px;
}

.image {
    margin: 38px 0 72px;
    width: 100%;
}

@media screen and (max-width: 800px) {
    .card_flex {
        flex-wrap: wrap;
    }
}
</style>
